import Vue from 'vue';
import { Currency } from '../constants/currency';

Vue.filter('toFixed', (value: number, fractionDigits: number) => {
  return +value.toFixed(fractionDigits);
});

Vue.filter('numeric', (value: number) => {
  return (value || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

Vue.filter('currency', (value: number | string, currency: Currency = Currency.Yen) => {
  if (!value) {
    return null;
  }
  return currency === Currency.Yen ? currency + value : value + ' ' + currency;
});
